import { gql } from '@apollo/client';

export const REQUEST_MEDIA_UPLOAD = gql`
  mutation RequestMediaUpload($input: RequestMediaUploadInput!) {
    requestMediaUpload(input: $input) {
      key
      s3Key
      uploadUrl
      fields
      expiresAt
      method
    }
  }
`;

export const REQUEST_MEDIA_UPLOAD_BATCH = gql`
  mutation RequestMediaUploadBatch($input: RequestMediaUploadBatchInput!) {
    requestMediaUploadBatch(input: $input) {
      key
      s3Key
      uploadUrl
      fields
      expiresAt
      method
    }
  }
`;

export const DELETE_MEDIA_OBJECT = gql`
  mutation DeleteMediaObject($input: DeleteMediaObjectInput!) {
    deleteMediaObject(input: $input) {
      key
      deleted
    }
  }
`;
